import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import { EditFaq, CreateFaq as CreateFaqAPI } from '../../../API/admin'
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import {
    CCard,
    CCardBody,
} from '@coreui/react';

const CreateFaq = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'FAQ', to: '/faq', active: false },
        { label: 'Edit', to: '', active: true }
    ];

    const { enqueueSnackbar ,closeSnackbar  } = useSnackbar();
    const navigate = useNavigate();
    const [userexist, setUserExist] = useState(false);
    const [DisableRegister, setDisableRegister] = useState(false);
    const [errors, setErrors] = useState({});
    const [CriteriaShow, setCriteriaShow] = useState(false);
    const [FormData, setFormData] = useState({
        question: '',
        answer: '',
        id: ''
    })

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        var urlid = {
            data: urlParams.get('id')
        }
        let callAPI = async () => {
            let res = await EditFaq(urlid);
            if (res.status) {
                setFormData(res.data);
            }
        }
        if (urlid) {
            callAPI();
        }
    }, [])

    // const HandelChange = (event ) => {
    //     if (event.target.name == 'answer') {
    //         const isValid = event.target.value.trim().length > 0;
            

    //         if (!isValid) {
    //             return event.target.setCustomValidity("Input cannot be empty or just blank spaces.");
    //         } else {
    //             return event.target.setCustomValidity("");
    //         }
        
    //     }
    //     const { name, value } = event.target;
    //     setFormData(prevState => ({
    //         ...prevState,
    //         [name]: value
    //     }));
    // }
    const HandelChange = (event) => {
        const { name, value } = event.target;
    
        if (name === 'answer') {
            const isValid = value.trim().length > 0;
    
            if (!isValid) {
                event.target.setCustomValidity("Input cannot be empty or just blank spaces.");
            } else {
                event.target.setCustomValidity("");
            }
        }
    
        // Update the form data state regardless of validation
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    

    const HandelSubmit = async (event) => {
        event.preventDefault();

        let res = await CreateFaqAPI(FormData)
        if (res.data.status) {
            enqueueSnackbar('FAQ saved successfully', { variant: 'success' , action: (key) => (
                <button className='toast_close_btn'
                    onClick={() => {
                        // Close the Snackbar
                        closeSnackbar(key);
                    }}
                >
                    X
                </button>
            ),});
            navigate('/faq');
        }
        else {
            // swal("Oops!", res.data.message, "error");
            enqueueSnackbar('Unable to save FAQ', { variant: 'error' , action: (key) => (
                <button className='toast_close_btn'
                    onClick={() => {
                        // Close the Snackbar
                        closeSnackbar(key);
                    }}
                >
                    X
                </button>
            ), });
            // swal("Oops!", res.data.message, "error");
        }

    }





    return (
        <>
            <h4 className="card-title mb-3 align-items-center">
                Create a FAQ
            </h4>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />

            <CCard className="mb-4">
                <CCardBody>
                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <form onSubmit={HandelSubmit}>
                                <div className='row mb-4'>
                                    <div className="col-12">
                                        <label htmlFor="exampleInputEmail1" className="form-label">
                                            Question
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name='question'
                                            onChange={HandelChange}
                                            value={FormData.question}
                                            placeholder='Enter Question'
                                            pattern=".*\S.*"
                                            title="Input cannot be empty or just blank spaces."
                                            required
                                        />

                                        <input type="hidden" value={FormData.id} name='id' />
                                    </div>
                                    <div className="col-12">

                                        <label htmlFor="exampleInputEmail1" className="form-label">
                                            Answer
                                        </label>
                                        <textarea
                                            onChange={HandelChange}
                                            value={FormData.answer}
                                            className="form-control"
                                            name='answer'
                                            placeholder='Enter answer'
                                            pattern=".*\S.*"
                                            title="Input cannot be empty or just blank spaces."
                                            required
                                        >

                                        </textarea>


                                    </div>
                                </div>
                                <button type="button" className="btn btn-secondary ms-3 float-end" onClick={() => window.history.back()}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary float-end" >
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </>
    )
}
export default CreateFaq;